import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class LotteryService {

    constructor(
        private httpService: HttpService) { }

    //获取所有彩种
    getLotterys() {
        var url = AppConfig.GetProdUrl() + "/Lottery/GetLotterys";
        return this.httpService.get(url);
    }

    //获取六合彩生肖年份及起始期号配置
    getSixSetting() {
        var url = AppConfig.GetProdUrl() + "/Lottery/MarksixSettings";
        return this.httpService.get(url);
    }
}







// WEBPACK FOOTER //
// ./src/services/lottery.service.ts